import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { profileKeys, UserProfileData } from "../profile";
import { VerifyOTPVariables } from "./types";

export const useVerifyOTP = (
  options?: UseMutationOptions<
    UserProfileData,
    PortalAxiosError,
    VerifyOTPVariables
  >
) => {
  const server = useServer();
  const queryClient = useQueryClient();

  return useMutation<UserProfileData, PortalAxiosError, VerifyOTPVariables>(
    (variables) => server.post("user/verify_otp", variables),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.setQueryData(profileKeys.get, data);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};

export default useVerifyOTP;
